import { getAppConfig } from "./config"
import ngRoute = angular.route
import * as angular from "angular"
import { setupUsersnap } from "./shared/usersnap"
import { setupModules } from "./appmodules"
import { createRegistrationContext } from "./shared/loader"
import { setupBlockUi } from "./blockUi"
import { setupPromises } from "./shared/promises"
import { setupMessageProvider } from "./shared/i18n/providers"
import { ShellService } from "./shared/shell/shell"
import { IOmniaSession, OmniaAppId } from "./shared/types"
import { I18nService } from "./shared/i18n/types"
import { OmniaConfig } from "./shared/config"
import { setupGlobalContext } from "./shared/react/context"
import { setupShared } from "./shared/setup"
import { omnia } from "./exports/omnia"
import { LicenseInfo } from "@mui/x-license"

import "ol/ol.css"
import "./styles/openlayers.css"

// These files install various polyfills, and are not referenced by any other,
// so must be imported explicitly to make sure it will be bundled
import "./shared/utils/array-prototype"
import "./shared/utils/set-prototype"

(<any>Error).stackTraceLimit = 100

export { omnia }

LicenseInfo.setLicenseKey(
    "3ad2f41ec9de86d9cc9abd44604bf18aTz04ODIwMSxFPTE3NDQzOTc2MzEwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI="
)

const module = angular.module("omnia")

setupOmnia(() => {

    const body = angular.element(document).find("body")

    angular.bootstrap(body, ["omnia"])

})

/**
 * This is the entry point for the application.
 * It is called first (see above) when the script is loaded.
 * It registers all Angular services and components, but does not bootstrap Angular the application yet.
 * The Angular app is bootstrapped only later, once modules have been loaded.
 *
 * @param callback Called when all the required Omnia modules have been loaded
 */
function setupOmnia(callback: () => void) {

    setupAngularModule(module)

    // Get host-dependent (i.e., URL dependent) settings
    const config = getAppConfig()

    setupDocument(config)

    setupUsersnap(config.usersnapKey)

    module.constant("omniaApiUrl", config.apiUrl)
    module.constant("omniaConfig", config)
    module.constant("omniaSessionState", { state: undefined })

    setupShared(module)

    setupModules(module, createRegistrationContext(module), callback, config)

    module.config(["$locationProvider", ($locationProvider: ng.ILocationProvider) => {
        $locationProvider.hashPrefix("")
    }])

    module.config(["$uibTooltipProvider", provider => {

        provider.options({
            appendToBody: true,
            placement: "bottom",
            popupDelay: 0
        });

    }]);

    module.config(["blockUIConfig", "omniaConfig", "omniaSessionState", setupBlockUi])

    module.run(["$q", setupPromises])

    module.run(["OmniaI18n", "omniaConfig", setupMessageProvider])

    module.run(["$route", "OmniaShell", ($route: ngRoute.IRouteService, shell: ShellService) => {
        shell.setup($route)
    }])

    module.run(["OmniaSession", "OmniaI18n", "omniaConfig", (session: IOmniaSession, i18n: I18nService, config: OmniaConfig) => {

        setupGlobalContext(session, i18n, config)

    }])

    return module

}

/**
 * This patches a few methods on a ng.IModule object, to be able to emit
 * a console message if trying to register a service/component that has not been loaded yet
 *
 * @param module Angular module
 */
function setupAngularModule(module: ng.IModule) {

    var dir = module.directive;

    (<any>module).directive = (name, factory) => {
        if (!factory) console.log("Undefined factory for directive: ", name);
        return dir.call(module, name, factory);
    };

    var service = module.service;

    (<any>module).service = (name, factory) => {
        if (!factory) console.log("Undefined factory for service: ", name);
        return service.call(module, name, factory);
    };

    var provider = module.provider;

    (<any>module).provider = (name, factory) => {
        if (!factory) console.log("Undefined factory for provider: ", name);
        return provider.call(module, name, factory);
    };

}


function setupDocument({ appId, baseUrl, brand }: OmniaConfig) {

    document.title = brand.name

    if (appId == OmniaAppId.Omnia) {
        // The default index.html files matches this appId
        return
    }

    const links = Array.from<HTMLLinkElement>(document.querySelectorAll("head > link"))

    const icons = links.filter(l => /^(icon|apple-touch-icon)$/.test(l.rel))

    const nameRegex = /\/([^\/]+)$/
    const images = brand.images

    for (const link of icons) {

        const m = nameRegex.exec(link.href)

        if (m) {
            const name = m[1]
            link.href = `${baseUrl}/images/brand/${images}/${name}`
        }

    }

}
